const stringValue = (value) => {

    if (value === null) {
        return ''
    }

    if (typeof value == 'boolean') {
        return value ? 'Y' : 'N'
    }
    if (value instanceof Date) {
        return value.toISOString()
    }
    return value.toString()
}

const getFlatFields = (fields = []) => {
    return fields.reduce((acc, inc) => {
        return [...acc, inc, ...getFlatFields(inc.fields)]
    }, []).filter(field => !!field.id)
}

const getFieldMap = (fields = []) => {
    return getFlatFields(fields).reduce((acc, inc) => {
        return { ...acc, [inc.id]: inc }
    }, {})
}



export const getFormValue = (fields = [], values = {}) => {
    return fields.reduce((acc, { id, type }) => {

        if (typeof values[id] == 'undefined')
            return { ...acc, [id]: null }

        if (Array.isArray(values[id])) {

            if (values[id].every(v => typeof v == undefined || v == null)) {
                return { ...acc, [id]: null }
            }

            else {
                return { ...acc, [id]: values[id].filter(v => typeof v != 'undefined').map(stringValue) }
            }
        }

        if (type === 'number' && values[id] === '') {
            return { ...acc, [id]: null }
        }

        return { ...acc, [id]: values[id] }

    }, {})
}

export const getFormValueMap = (fields = [], values = {}) => {
    const fieldMap = getFieldMap(fields)
    return Object.entries(values).reduce((acc, [id, value]) => {

        if (typeof value != 'undefined' && value != null && fieldMap[id]) {
            return [
                ...acc,
                {
                    id,
                    type: fieldMap[id].type,
                    value: [].concat(value).map(stringValue),
                }
            ]
        }

        return acc
    }, [])
}